<template>
  <v-row class="pa-6 pb-2" style="border-radius: 6px">
    <v-col
      v-for="(key, i) in Object.keys(items)"
      :key="key"
      :cols="i === 2 ? 12 : 6"
      class="d-flex flex-column align-center justify-center pa-0"
      :style="{ 'background-color': colors[i] }"
    >
      <p
        style="margin-bottom: 0; font-size: 42px; font-weight: 500; line-height: 1.2; color: #ffffff"
      >
        {{ items[key].value }}
      </p>
      <p
        style="margin-bottom: 0; font-size: 12px; font-weight: 500; text-transform: uppercase; color: #ffffff"
      >
        {{ items[key].title }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "CompanyInfoTotal",
  props: {
    items: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    colors: ["#ea5329", "#FFC349", "#676766"]
  })
};
</script>

<style scoped></style>
